import type { Module } from 'vuex';
import { TranslateLanguageGroupItem } from '@/types/TranslateLanguageGroupItem';
import {RootState} from "@/store";

export interface TranslateLanguageGroupItemsState {
  translateLanguageGroupItems: TranslateLanguageGroupItem[];
}

const translateLanguageGroupItemsModule: Module<TranslateLanguageGroupItemsState, RootState> = {
  namespaced: true,

  state: (): TranslateLanguageGroupItemsState => ({
    translateLanguageGroupItems: [],
  }),

  getters: {
    getById: (state) => (idTranslateLanguageGroupItem: number): TranslateLanguageGroupItem | undefined => {
      return state.translateLanguageGroupItems.find(translateLanguageGroupItem => translateLanguageGroupItem.idTranslateLanguageGroupItem === idTranslateLanguageGroupItem);
    },
    getByLanguageGroupItem: (state) => (idLanguageGroupItem: number): TranslateLanguageGroupItem[] => {
      return state.translateLanguageGroupItems.filter(translateLanguageGroupItem => translateLanguageGroupItem.idLanguageGroupItem === idLanguageGroupItem);
    },
  },

  mutations: {
    setTranslateLanguageGroupItems(
      state,
      payload: { translateLanguageGroupItems: Record<number, any> }
    ) {
      state.translateLanguageGroupItems = Object
        .values(payload.translateLanguageGroupItems)
        .map(raw => TranslateLanguageGroupItem.fromRaw(raw));
    },

    setTranslateLanguageGroupItemCreate(
      state,
      payload: {
        idTranslateLanguageGroupItem: number;
        idLanguageGroupItem: number;
        idLanguage: number;
        text: string;
      }
    ) {
      const raw = {
        idTranslateLanguageGroupItem: payload.idTranslateLanguageGroupItem,
        idLanguageGroupItem: payload.idLanguageGroupItem,
        idLanguage: payload.idLanguage,
        text: payload.text,
        locked: false,
      };
      state.translateLanguageGroupItems.push(TranslateLanguageGroupItem.fromRaw(raw));
    },

    setTranslateLanguageGroupItemUpdate(
      state,
      payload: {
        idTranslateLanguageGroupItem: number;
        text?: string;
      }
    ) {
      const translateLanguageGroupItem = state.translateLanguageGroupItems.find(translateLanguageGroupItem => translateLanguageGroupItem.idTranslateLanguageGroupItem === payload.idTranslateLanguageGroupItem);
      if (!translateLanguageGroupItem) return;
      if (payload.text !== undefined) translateLanguageGroupItem.text = payload.text;
    },

    setTranslateLanguageGroupItemDelete(
      state,
      payload: { idTranslateLanguageGroupItem: number }
    ) {
      state.translateLanguageGroupItems = state.translateLanguageGroupItems.filter(
        translateLanguageGroupItem => translateLanguageGroupItem.idTranslateLanguageGroupItem !== payload.idTranslateLanguageGroupItem
      );
    },

    setTranslateLanguageGroupItemLock(
      state,
      payload: { idTranslateLanguageGroupItem: number }
    ) {
      const translateLanguageGroupItem = state.translateLanguageGroupItems.find(translateLanguageGroupItem => translateLanguageGroupItem.idTranslateLanguageGroupItem === payload.idTranslateLanguageGroupItem);
      if (translateLanguageGroupItem) translateLanguageGroupItem.locked = true;
    },

    setTranslateLanguageGroupItemUnlock(
      state,
      payload: { idTranslateLanguageGroupItem: number }
    ) {
      const translateLanguageGroupItem = state.translateLanguageGroupItems.find(translateLanguageGroupItem => translateLanguageGroupItem.idTranslateLanguageGroupItem === payload.idTranslateLanguageGroupItem);
      if (translateLanguageGroupItem) translateLanguageGroupItem.locked = false;
    },
  },

  actions: {
    wsSetTranslateLanguageGroupItems({ commit }, payload) {
      commit('setTranslateLanguageGroupItems', payload);
    },
    wsTranslateLanguageGroupItemCreate({ commit }, payload) {
      commit('setTranslateLanguageGroupItemCreate', payload);
    },
    wsTranslateLanguageGroupItemUpdate({ commit }, payload) {
      commit('setTranslateLanguageGroupItemUpdate', payload);
    },
    wsTranslateLanguageGroupItemDelete({ commit }, payload) {
      commit('setTranslateLanguageGroupItemDelete', payload);
    },
    wsTranslateLanguageGroupItemLock({ commit }, payload) {
      commit('setTranslateLanguageGroupItemLock', payload);
    },
    wsTranslateLanguageGroupItemUnlock({ commit }, payload) {
      commit('setTranslateLanguageGroupItemUnlock', payload);
    },
  },
};

export default translateLanguageGroupItemsModule;
